import React, { useState, useEffect } from 'react'
import Button from '@/components/Button'
import styled from 'styled-components'
import useSiteContext from '@/context/SiteContext'
import useForm from './useForm'

const Form = ({ btnColor, accentColor, bgColor, foregroundColor }) => {
  const { saveEmail, setOptin } = useSiteContext()
  const {
    values,
    touchedValues,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useForm({
    initialValues: {
      email: '',
    },
    onSubmit(values) {
      const err = values.e ? values.e : null
      const val = values.values ? values.values : null
      console.log(err, val, values)

      if (Object.keys(err).length > 0) {
        // console.log('nope:', err)
      } else {
        // console.log('yep', val)
        // setOptin(val.optin)

        saveEmail(val.email)
      }
    },
    validate(values) {
      const errorobj = {}
      if (values.email === '') {
        errorobj.email = 'Ingresa un correo'
      } else if (!values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        errorobj.email = 'Email inválido'
      }
      return errorobj
    },
  })

  return (
    <form onSubmit={handleSubmit}>
      <Label
        style={{
          backgroundColor: foregroundColor ? 'white' : 'transparent',
          color: '#000',
        }}>
        <svg
          viewBox="0 0 24 24"
          width="16"
          height="16"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          shapeRendering="geometricPrecision">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
          <path d="M22 6l-10 7L2 6"></path>
        </svg>
        <input
          type="email"
          className="iemail"
          name="email"
          value={values.email}
          onChange={handleChange}
          placeholder="Ej: tu@email.com"
        />
        <Button
          type="submit"
          as="button"
          className={`py-2 sm:py-3 sbm-btn ${btnColor ? `` : 'text-white'} ${
            accentColor ? `` : 'bg-azul'
          }`}
          style={{
            backgroundColor: accentColor ? accentColor : null,
            color: btnColor ? btnColor : null,
          }}>
          <span className="hidden sm:inline">Continuar</span>
          <span className="sm:hidden inline">Ir</span>
        </Button>
      </Label>
      <span className="block p-2 text-xs ">
        Al registrarte aceptas los{' '}
        <a
          className="underline"
          href="https://www.latercera.com/terminos-y-condiciones/"
          target="_blank"
          rel="noopener noreferrer">
          términos y condiciones
        </a>
      </span>
    </form>
  )
}

const Label = styled.label`
  width: 100%;
  padding-left: 1rem /* 16px */;
  padding-right: 0.25rem /* 4px */;
  padding-top: 0.25rem /* 4px */;
  padding-bottom: 0.25rem /* 4px */;
  line-height: 1;
  border-width: 1px;
  border-radius: 0.375rem /* 6px */;
  display: flex;
  gap: 3px;
  align-items: center;
  justify-content: space-between;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-border-opacity: 1;
  border-color: rgb(189 189 189 / var(--tw-border-opacity));
  border-width: 1px;
  &:focus {
    border-color: rgba(23, 40, 63, 1);
  }

  .sbm-btn {
    min-width: 60px;
    flex-shrink: 0;
  }

  .iemail {
    flex-grow: 1;
    outline: 2px solid transparent;
    outline-offset: 2px;
    appearance: none;
    background-color: transparent;
  }

  @media (max-width: 768px) {
    padding-left: 0.4rem;
    .sbm-btn {
      min-width: 60px;
      padding-left: 0.2rem;
      padding-right: 0.2rem;
      align-self: flex-end;
      justify-self: flex-end;
    }
  }

  @media (max-width: 350px) {
    .iemail {
      flex-grow: 0;
      flex-shrink: 1;
      max-width: calc(100% - 80px);
    }
  }
`

export default Form
